module.exports = __webpack_public_path__ + "img/kids_web.32dcce3f.png";